import { useEffect, useRef, useState } from "react";
import { subscribe } from "./live";

let offset = 0;
export const syncClock = (serverNow) => { if (serverNow) offset = serverNow - Date.now(); };
export const now = () => Date.now() + offset;

const hm = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
const dayFmt = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", weekday: "short", day: "numeric", month: "short" });
export const istHM24 = (ms) => (ms ? hm.format(new Date(ms)) : "");
// "9:30 am", "12:00 am", "2:30:15 pm" from "HH:MM" or "HH:MM:SS"
export function hm12(hhmm) {
  const [h, m, s] = hhmm.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")}${s != null ? `:${String(s).padStart(2, "0")}` : ""} ${h < 12 ? "am" : "pm"}`;
}
export const istHM = (ms) => (ms ? hm12(istHM24(ms)) : "");
const hms = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });
export const istHMS = (ms) => hm12(hms.format(new Date(ms)));
export const dayLabel = (iso) => dayFmt.format(new Date(`${iso}T12:00:00+05:30`)).replace(",", "").replace("Sept", "Sep");

// the one duration format: "0h 01m", "7h 30m", "142h 10m"
export function hmin(minutes) {
  const m = Math.max(0, Math.round(minutes));
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
}
export const dur = (ms) => hmin(Math.floor(Math.max(0, ms) / 60000));
export const hrs = (h) => hmin((h || 0) * 60);

export function clock(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const p = (n) => String(n).padStart(2, "0");
  return `${Math.floor(s / 3600)}:${p(Math.floor(s / 60) % 60)}:${p(s % 60)}`;
}

export function useTick(ms = 1000) {
  const [, set] = useState(0);
  useEffect(() => { const t = setInterval(() => set((x) => x + 1), ms); return () => clearInterval(t); }, [ms]);
  return now();
}

// onChange(types) runs once per ~400 ms batch of live events; wants(type) limits which event types matter.
export function useLive(onChange, wants) {
  const cb = useRef(onChange);
  cb.current = onChange;
  const w = useRef(wants);
  useEffect(() => subscribe({ cb, wants: w.current }), []);
}

export function hue(code) {
  let h = 0;
  for (const ch of code || "") h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}
